import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'bets4',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-S9E0G3W1VY']
    })
  ]
})

/* Track a page view */
analytics.page()
